var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Curseur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12.427734 3.0019531 A 1.50015 1.50015 0 0 0 11 4.5 L 11 35.5 A 1.50015 1.50015 0 0 0 13.4375 36.671875 L 19.466797 31.845703 L 24.787109 44.097656 A 1.50015 1.50015 0 0 0 26.759766 44.875 L 32.265625 42.484375 A 1.50015 1.50015 0 0 0 33.042969 40.511719 L 27.785156 28.402344 L 35.671875 27.490234 A 1.50015 1.50015 0 0 0 36.523438 24.904297 L 13.523438 3.4042969 A 1.50015 1.50015 0 0 0 12.427734 3.0019531 z M 14 7.9550781 L 32.109375 24.882812 L 25.429688 25.654297 A 1.50015 1.50015 0 0 0 24.226562 27.742188 L 29.693359 40.330078 L 26.941406 41.525391 L 21.4375 28.851562 A 1.50015 1.50015 0 0 0 19.125 28.277344 L 14 32.376953 L 14 7.9550781 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Curseur);
export default __webpack_public_path__ + "static/media/icons8-curseur.b43d7dba84ba5f6b30b3dc8c5dd2c947.svg";
export { ForwardRef as ReactComponent };